module.exports = __webpack_public_path__ + "static/media/rajeshwari.6c5e8b22.png";